const _excluded = ["size"];
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
      (o = n[r]),
        -1 === t.indexOf(o) &&
          {}.propertyIsEnumerable.call(e, o) &&
          (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  return t;
}
function _extends() {
  return (
    (_extends = Object.assign
      ? Object.assign.bind()
      : function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = arguments[e];
            for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }
          return n;
        }),
    _extends.apply(null, arguments)
  );
}
import React from "react";
var SumUpLogomark24 = function SumUpLogomark24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    _extends(
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
      props,
    ),
    /*#__PURE__*/ React.createElement("path", {
      d: "M22.29 0H1.7C.77 0 0 .77 0 1.71V22.3c0 .93.77 1.7 1.71 1.7H22.3c.94 0 1.71-.77 1.71-1.71V1.7C24 .77 23.23 0 22.29 0Zm-7.22 18.07a5.62 5.62 0 0 1-7.68.24.36.36 0 0 1-.01-.49l7.44-7.44a.35.35 0 0 1 .49 0 5.6 5.6 0 0 1-.24 7.69Zm1.55-11.9-7.44 7.45a.35.35 0 0 1-.5 0 5.61 5.61 0 0 1 7.9-7.96l.03.03c.13.13.14.35.01.49Z",
      fill: "currentColor",
    }),
  );
};
const sizeMap = {
  24: SumUpLogomark24,
};
export function SumUpLogomark(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    console.warn(
      new Error(
        "The '".concat(
          size,
          "' size is not supported by the 'SumUpLogomark' icon. Please use one of the available sizes: '24'.",
        ),
      ),
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
